import React from 'react';
import { Box, Text, VStack, IconButton, Tooltip } from '@chakra-ui/react';
import { FaWhatsapp } from 'react-icons/fa';
import { GiPadlock } from 'react-icons/gi';

const WHATSAPP_URL = 'https://wa.me/5508002802133?text=Ol%C3%A1%2C%20tenho%20uma%20d%C3%BAvida%20sobre%20meu%20pagamento.';

export default function VindiSupportBubble() {
  return (
    <Box position="fixed" bottom="20" right="4" zIndex={1000} display="flex" flexDirection="column" alignItems="flex-end" gap={2}>
      <Box
        bg="white"
        borderRadius="xl"
        boxShadow="md"
        border="1px solid #E0E0E0"
        px={3}
        py={2}
        maxW="160px"
      >
        <VStack spacing={0} align="flex-start">
          <Box display="flex" alignItems="center" gap={1}>
            <GiPadlock size={11} color="#5AB2AE" />
            <Text fontSize="9px" color="#9E9E9E" fontWeight="medium" letterSpacing="wide" textTransform="uppercase">
              Pagamento seguro
            </Text>
          </Box>
          <Text fontSize="11px" color="#424242" fontWeight="bold" lineHeight="1.3">
            Intermediado por{' '}
            <Text as="span" color="#5AB2AE">
              Vindi
            </Text>
          </Text>
          <Text fontSize="9px" color="#9E9E9E" lineHeight="1.3">
            Dúvidas? Fale com o suporte
          </Text>
        </VStack>
      </Box>

      <Tooltip label="Falar com o suporte" placement="left" hasArrow>
        <IconButton
          as="a"
          href={WHATSAPP_URL}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Suporte via WhatsApp"
          icon={<FaWhatsapp size={26} />}
          bg="#25D366"
          color="white"
          borderRadius="full"
          w="52px"
          h="52px"
          boxShadow="lg"
          _hover={{ bg: '#1EBE58', transform: 'scale(1.05)' }}
          _active={{ bg: '#18A04A' }}
          transition="all 0.2s"
        />
      </Tooltip>
    </Box>
  );
}
